
window.CVT = (function () { var T = {"fr": {"rv": "Avis", "gov": "Aller à la vidéo", "of5": " sur 5", "ph": "Photo partagée par", "see": "Voir la photo de", "ver": "Vérifié", "rep": "Réponse de Cocoony :", "err": "Une erreur est survenue, veuillez réessayer."}, "de": {"rv": "Bewertung", "gov": "Zu Video", "of5": " von 5", "ph": "Foto von", "see": "Foto ansehen von", "ver": "Verifiziert", "rep": "Antwort von Cocoony:", "err": "Ein Fehler ist aufgetreten, bitte versuchen Sie es erneut."}}; return T[(document.documentElement.lang || 'fr').slice(0, 2) === 'de' ? 'de' : 'fr']; })();
(function () {
  if (window.__cvPdp) return; window.__cvPdp = true;
  var TZ = 'Europe/Zurich', END = '2026-11-30';
  function $a(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }
  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  function zh() {
    var o = {}; new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' }).formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
    o.date = o.year + '-' + o.month + '-' + o.day; return o;
  }
  function two(n) { return (n < 10 ? '0' : '') + n; }
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/', SEC = 'cart-drawer,cart-icon-bubble', GIFT = 55596412469589;
  function post(url, body) {
    return fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || ''); return j; }); });
  }
  function addAndOpen(vid, btn, onfail) {
    btn.classList.add('is-busy');
    
    return post('cart/add.js', { items: [{ id: GIFT, quantity: 1 }, { id: vid, quantity: 1 }] })
      .then(function () { return post('cart/update.js', { updates: {}, sections: SEC, sections_url: location.pathname }); })
      .then(function (st) {
        btn.classList.remove('is-busy');
        var d = document.querySelector('cart-drawer');
        if (d && d.renderContents && st && st.sections) { st.id = vid; d.classList.remove('is-empty'); d.renderContents(st); }
        else location.href = root + 'cart';
      })
      .catch(function (e) { btn.classList.remove('is-busy'); onfail(e); });
  }
  ready(function () {
    
    var timers = $a('[data-cv-timer]'), wraps = $a('[data-cv-cdw]'), bar = document.getElementById('cvbf'), tag = document.querySelector('.cv-pf__tag');
    function tick() {
      var n = zh();
      if (n.date > END) { wraps.forEach(function (w) { w.hidden = true; w.style.display = 'none'; }); if (bar) bar.hidden = true; if (tag) tag.hidden = true; clearInterval(iv); return; }
      var left = 86400 - (+n.hour * 3600 + +n.minute * 60 + +n.second), t = two(Math.floor(left / 3600)) + ':' + two(Math.floor(left % 3600 / 60)) + ':' + two(left % 60);
      timers.forEach(function (x) { x.textContent = t; });
    }
    var iv = setInterval(tick, 1000); tick();
    
    var card = document.getElementById('cv-offre');
    if (card) { var sz = function () { card.classList.toggle('is-lg', card.offsetWidth >= LG); }; var LG = 520; sz(); window.addEventListener('resize', sz); }
    
    $a('[data-cv-gal]').forEach(function (g) {
      var sl = g.querySelector('.cv-gal__slides'), th = $a('.cv-gal__thumb', g), n = th.length, cur = 0, tb = g.querySelector('.cv-gal__thumbs');
      function mark(i) { cur = i; th.forEach(function (t, k) { t.classList.toggle('is-on', k === i); }); var t = th[i]; if (t && tb) tb.scrollTo({ left: t.offsetLeft - tb.offsetLeft - tb.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' }); }
      function go(i) { i = (i + n) % n; var im = sl.children[i] && sl.children[i].querySelector('img'); if (im) im.loading = 'eager'; sl.scrollTo({ left: sl.clientWidth * i, behavior: 'smooth' }); mark(i); }
      th.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
      $a('.cv-gal__nav', g).forEach(function (b) { b.addEventListener('click', function () { go(cur + parseInt(b.getAttribute('data-dir'), 10)); }); });
      var w; sl.addEventListener('scroll', function () { clearTimeout(w); w = setTimeout(function () { var i = Math.round(sl.scrollLeft / (sl.clientWidth || 1)); if (i !== cur) mark(i); }, 90); }, { passive: true });
    });
    
    var err = document.querySelector('[data-cv-err]');
    $a('[data-cv-atc]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (err) err.hidden = true;
        addAndOpen(Number(b.getAttribute('data-variant')), b, function (e) { if (err) { err.textContent = e.message || CVT.err; err.hidden = false; } });
      });
    });
    
    $a('[data-cv-acc]').forEach(function (list) {
      list.addEventListener('click', function (e) {
        var q = e.target.closest('[data-q]'); if (!q || !list.contains(q)) return;
        var it = q.parentElement, open = it.classList.contains('is-open');
        it.classList.toggle('is-open', !open); q.setAttribute('aria-expanded', open ? 'false' : 'true');
        var a = it.querySelector('[data-a]'); if (a) a.hidden = open;
      });
    });
    
    var pf = document.getElementById('cv-pf'), atc = document.querySelector('.cv-info [data-cv-atc]');
    if (pf && atc) {
      document.body.appendChild(pf);
      var upd = function () { var on = atc.getBoundingClientRect().bottom < 0; pf.classList.toggle('is-on', on); pf.setAttribute('aria-hidden', on ? 'false' : 'true'); };
      window.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
    }
  });
})();


(function(){
  var motion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

  document.querySelectorAll('.cv-avis').forEach(function(root){
    if(root.dataset.ready) return;
    root.dataset.ready = '1';

    var track = root.querySelector('.cv-avis__track');
    if(!track) return;
    var cards = [].slice.call(track.querySelectorAll('.cv-avis__card'));
    var dotsWrap = root.querySelector('.cv-avis__dots');

    
    cards.forEach(function(card, i){
      var b = document.createElement('button');
      b.className = 'cv-avis__dot' + (i === 0 ? ' is-active' : '');
      b.setAttribute('aria-label', CVT.rv + ' ' + (i + 1));
      b.addEventListener('click', function(){
        track.scrollTo({left: card.offsetLeft - cards[0].offsetLeft, behavior:motion});
      });
      dotsWrap.appendChild(b);
    });
    var dots = [].slice.call(dotsWrap.children);

    
    function step(){
      return cards[1] ? cards[1].offsetLeft - cards[0].offsetLeft : cards[0].offsetWidth + 16;
    }

    root.querySelectorAll('.cv-avis__arrow').forEach(function(btn){
      btn.addEventListener('click', function(){
        var dir = parseInt(btn.getAttribute('data-dir'), 10);
        var max = track.scrollWidth - track.clientWidth;
        if(dir > 0 && track.scrollLeft >= max - 4){
          track.scrollTo({left:0, behavior:motion});
        } else if(dir < 0 && track.scrollLeft <= 4){
          track.scrollTo({left:max, behavior:motion});
        } else {
          track.scrollBy({left: dir * step(), behavior:motion});
        }
      });
    });

    
    function checkStatic(){
      root.classList.toggle('is-static', track.scrollWidth <= track.clientWidth + 2);
    }
    checkStatic();
    window.addEventListener('resize', checkStatic);

    
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          var idx = cards.indexOf(e.target);
          dots.forEach(function(d, i){ d.classList.toggle('is-active', i === idx); });
        }
      });
    }, {root:track, threshold:0.6});
    cards.forEach(function(c){ obs.observe(c); });

    
    var modal = root.querySelector('.cv-avis__modal');
    var mTitle = root.querySelector('.cv-avis__modalTitle');
    var mText = root.querySelector('.cv-avis__modalText');
    var mName = root.querySelector('.cv-avis__modalName');
    var closeBtn = modal.querySelector('.cv-avis__close');
    var lastFocus = null;

    function openModal(card){
      mTitle.textContent = card.querySelector('.cv-avis__cardTitle').textContent;
      mText.textContent = card.querySelector('.cv-avis__text').textContent;
      mName.textContent = card.querySelector('.cv-avis__nameText').textContent;
      lastFocus = document.activeElement;
      modal.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      closeBtn.focus();
    }

    function closeModal(){
      modal.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      if(lastFocus) lastFocus.focus();
    }

    cards.forEach(function(card){
      card.addEventListener('click', function(){ openModal(card); });
      card.addEventListener('keydown', function(e){
        if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); openModal(card); }
      });
    });

    closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', function(e){ if(e.target === modal) closeModal(); });
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
  });
})();


(function(){
  
  document.querySelectorAll('[data-rz-cta]').forEach(function(btn){
    if(btn.dataset.ready) return;
    btn.dataset.ready = '1';
    btn.addEventListener('click', function(){
      var target = document.getElementById('cv-offre');
      if(target){
        target.scrollIntoView({ behavior:'smooth', block:'center' });
      } else {
        window.scrollTo({ top:0, behavior:'smooth' });
      }
    });
  });
})();


(function(){
  
  document.querySelectorAll('.cv-tc').forEach(function(root){
    if(root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready', '1');

    var track = root.querySelector('[data-tc-track]');
    var tabs = [].slice.call(root.querySelectorAll('[data-tc-tab]'));
    var slides = [].slice.call(root.querySelectorAll('.cv-tc__slide'));
    if(!track || !tabs.length) return;

    var current = 0;

    function select(i){
      current = i;
      tabs.forEach(function(t, k){
        var on = k === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
      });
    }

    function goTo(i){
      i = Math.max(0, Math.min(slides.length - 1, i));
      select(i);
      track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
    }

    
    root.querySelectorAll('[data-tc-go]').forEach(function(btn){
      btn.addEventListener('click', function(){ goTo(+btn.getAttribute('data-tc-go')); });
    });

    tabs.forEach(function(t, k){
      t.addEventListener('click', function(){ goTo(k); });
      t.addEventListener('keydown', function(e){
        if(e.key === 'ArrowRight'){ e.preventDefault(); goTo(k + 1); tabs[current].focus(); }
        if(e.key === 'ArrowLeft'){ e.preventDefault(); goTo(k - 1); tabs[current].focus(); }
      });
    });

    
    var raf = null;
    track.addEventListener('scroll', function(){
      if(raf) return;
      raf = requestAnimationFrame(function(){
        raf = null;
        var x = track.scrollLeft, best = 0, dist = Infinity;
        slides.forEach(function(s, k){
          var d = Math.abs(s.offsetLeft - slides[0].offsetLeft - x);
          if(d < dist){ dist = d; best = k; }
        });
        if(best !== current) select(best);
      });
    }, { passive: true });
  });
})();


(function(){
  document.querySelectorAll('.cv-st').forEach(function(root){
    if(root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready', '1');

    
    var cta = root.querySelector('[data-st-cta]');
    if(cta){
      cta.addEventListener('click', function(){
        var target = document.getElementById('cv-offre');
        if(target){
          target.scrollIntoView({ behavior:'smooth', block:'center' });
        } else {
          window.scrollTo({ top:0, behavior:'smooth' });
        }
      });
    }

    
    var track = root.querySelector('[data-st-track]');
    var steps = [].slice.call(root.querySelectorAll('.cv-st__step'));
    var dots = [].slice.call(root.querySelectorAll('.cv-st__dot'));
    if(!track || !steps.length || !dots.length) return;

    var current = 0;

    function mark(i){
      current = i;
      dots.forEach(function(d, k){
        if(k === i){ d.setAttribute('aria-current', 'true'); }
        else { d.removeAttribute('aria-current'); }
      });
    }

    dots.forEach(function(d, k){
      d.addEventListener('click', function(){
        mark(k);
        track.scrollTo({ left: steps[k].offsetLeft - steps[0].offsetLeft, behavior: 'smooth' });
      });
    });

    var raf = null;
    track.addEventListener('scroll', function(){
      if(raf) return;
      raf = requestAnimationFrame(function(){
        raf = null;
        var x = track.scrollLeft, best = 0, dist = Infinity;
        var max = track.scrollWidth - track.clientWidth;
        if(max > 0 && x >= max - 4){ best = steps.length - 1; }
        else {
          steps.forEach(function(s, k){
            var dd = Math.abs(s.offsetLeft - steps[0].offsetLeft - x);
            if(dd < dist){ dist = dd; best = k; }
          });
        }
        if(best !== current) mark(best);
      });
    }, { passive: true });
  });
})();


(function(){
  
  var REVIEWS = []; try { REVIEWS = JSON.parse(document.getElementById("cv-rv-data").textContent); } catch (e) {}

  var PAGE = 8; 

  function src(url, w){ return url; }
  function el(tag, cls, text){ var e = document.createElement(tag); if(cls) e.className = cls; if(text != null) e.textContent = text; return e; }
  function stars(n){
    var s = el('span', 'cv-rv__stars');
    s.setAttribute('role', 'img');
    s.setAttribute('aria-label', n + CVT.of5);
    s.appendChild(document.createTextNode(new Array(n + 1).join('★')));
    if(n < 5) s.appendChild(el('span', 'cv-rv__starsOff', new Array(6 - n).join('★')));
    return s;
  }
  function norm(s){ return (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }

  document.querySelectorAll('.cv-rv').forEach(function(root){
    if(root.dataset.ready) return;
    root.dataset.ready = '1';

    var list = root.querySelector('.cv-rv__list');
    var strip = root.querySelector('.cv-rv__stripTrack');
    var stripNext = root.querySelector('.cv-rv__stripNext');
    var moreWrap = root.querySelector('.cv-rv__moreWrap');
    var more = root.querySelector('.cv-rv__more');
    var empty = root.querySelector('.cv-rv__empty');
    var searchWrap = root.querySelector('.cv-rv__searchWrap');
    var search = root.querySelector('.cv-rv__search');
    var btnSearch = root.querySelector('[data-tool="search"]');
    var btnPhotos = root.querySelector('[data-tool="photos"]');

    var shown = PAGE, query = '', onlyPhotos = false;

    
    var photos = [];
    REVIEWS.forEach(function(r){ r.i.forEach(function(u){ photos.push({r:r, u:u}); }); });

    var lb = root.querySelector('.cv-rv__lb');
    var lbImg = root.querySelector('.cv-rv__lbImg');
    var lbName = root.querySelector('.cv-rv__lbName');
    var lbTitle = root.querySelector('.cv-rv__lbTitle');
    var lbText = root.querySelector('.cv-rv__lbText');
    var lbStars = root.querySelector('.cv-rv__lbStars');
    var lbClose = root.querySelector('.cv-rv__lbClose');
    var cur = 0, lastFocus = null;

    function show(i){
      cur = (i + photos.length) % photos.length;
      var p = photos[cur];
      lbImg.src = src(p.u, 1024);
      lbImg.alt = CVT.ph + ' ' + p.r.n;
      lbName.textContent = p.r.n;
      lbStars.innerHTML = '';
      lbStars.appendChild(stars(p.r.s));
      lbTitle.textContent = p.r.t || '';
      lbText.textContent = p.r.b;
    }

    function openLb(u){
      var i = 0;
      photos.forEach(function(p, k){ if(p.u === u) i = k; });
      show(i);
      lastFocus = document.activeElement;
      lb.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      lbClose.focus();
    }

    function closeLb(){
      lb.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      if(lastFocus) lastFocus.focus();
    }

    root.querySelector('.cv-rv__lbNav--prev').addEventListener('click', function(){ show(cur - 1); });
    root.querySelector('.cv-rv__lbNav--next').addEventListener('click', function(){ show(cur + 1); });
    lbClose.addEventListener('click', closeLb);
    lb.addEventListener('click', function(e){ if(e.target === lb) closeLb(); });
    document.addEventListener('keydown', function(e){
      if(!lb.classList.contains('is-open')) return;
      if(e.key === 'Escape') closeLb();
      if(e.key === 'ArrowLeft') show(cur - 1);
      if(e.key === 'ArrowRight') show(cur + 1);
    });

    function shot(u, name, w){
      var b = el('button', 'cv-rv__shot');
      b.type = 'button';
      b.setAttribute('aria-label', CVT.see + ' ' + name);
      var img = el('img');
      img.src = src(u, w);
      img.alt = CVT.ph + ' ' + name;
      img.loading = 'lazy';
      img.decoding = 'async';
      img.onerror = function(){ b.remove(); };
      b.appendChild(img);
      b.addEventListener('click', function(){ openLb(u); });
      return b;
    }

    
    photos.forEach(function(p){ strip.appendChild(shot(p.u, p.r.n, 320)); });

    stripNext.addEventListener('click', function(){
      var max = strip.scrollWidth - strip.clientWidth;
      if(strip.scrollLeft >= max - 4) strip.scrollTo({left:0, behavior:'smooth'});
      else strip.scrollBy({left:strip.clientWidth * .8, behavior:'smooth'});
    });

    
    function card(r){
      var a = el('article', 'cv-rv__item');
      a.appendChild(stars(r.s));

      var head = el('div', 'cv-rv__itemHead');
      head.appendChild(el('p', 'cv-rv__name', r.n));
      head.appendChild(el('span', 'cv-rv__tag', CVT.ver));
      a.appendChild(head);

      if(r.t) a.appendChild(el('h3', 'cv-rv__itemTitle', r.t));
      a.appendChild(el('p', 'cv-rv__body', r.b));

      if(r.i.length){
        var th = el('div', 'cv-rv__thumbs');
        r.i.forEach(function(u){ th.appendChild(shot(u, r.n, 240)); });
        a.appendChild(th);
      }

      if(r.r){
        var rep = el('div', 'cv-rv__reply');
        rep.appendChild(el('p', 'cv-rv__replyLabel', CVT.rep));
        rep.appendChild(el('p', 'cv-rv__replyText', r.r));
        a.appendChild(rep);
      }
      return a;
    }

    function filtered(){
      var q = norm(query);
      return REVIEWS.filter(function(r){
        if(onlyPhotos && !r.i.length) return false;
        if(q && norm(r.n + ' ' + r.t + ' ' + r.b).indexOf(q) === -1) return false;
        return true;
      });
    }

    function render(){
      var items = filtered();
      list.innerHTML = '';
      items.slice(0, shown).forEach(function(r){ list.appendChild(card(r)); });
      moreWrap.hidden = items.length <= shown;
      empty.hidden = items.length > 0;
    }

    more.addEventListener('click', function(){ shown += PAGE; render(); });

    btnSearch.addEventListener('click', function(){
      var open = searchWrap.hidden;
      searchWrap.hidden = !open;
      btnSearch.setAttribute('aria-pressed', open ? 'true' : 'false');
      if(open){ search.focus(); }
      else { search.value = ''; query = ''; shown = PAGE; render(); }
    });

    search.addEventListener('input', function(){ query = search.value; shown = PAGE; render(); });

    btnPhotos.addEventListener('click', function(){
      onlyPhotos = !onlyPhotos;
      btnPhotos.setAttribute('aria-pressed', onlyPhotos ? 'true' : 'false');
      shown = PAGE;
      render();
    });

    render();
  });
})();


(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var behavior = reduce ? 'auto' : 'smooth';

  document.querySelectorAll('.cv-vs').forEach(function(root){
    if(root.dataset.ready) return;
    root.dataset.ready = '1';

    var track = root.querySelector('.cv-vs__track');
    var slides = [].slice.call(track.children);
    var videos = [].slice.call(root.querySelectorAll('video'));
    var dotsWrap = root.querySelector('.cv-vs__dots');
    var prev = root.querySelector('.cv-vs__arrow--prev');
    var next = root.querySelector('.cv-vs__arrow--next');

    
    videos.forEach(function(v){
      v.muted = true;
      v.defaultMuted = true;
      v.volume = 0;
      v.addEventListener('volumechange', function(){
        if(!v.muted || v.volume > 0){ v.muted = true; v.volume = 0; }
      });
    });

    
    function load(v){
      if(!v.getAttribute('src') && v.dataset.src){
        v.src = v.dataset.src + '#t=0.001'; 
        v.load();
      }
    }

    function play(v){
      load(v);
      var p = v.play();
      if(p && p.catch) p.catch(function(){});
    }

    if(!('IntersectionObserver' in window)){
      videos.forEach(play);
    } else {
      var near = new IntersectionObserver(function(entries){
        if(entries[0].isIntersecting){ videos.forEach(load); near.disconnect(); }
      }, {rootMargin:'400px 0px'});
      near.observe(root);

      
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          var v = e.target;
          v._dlVisible = e.isIntersecting;
          if(e.isIntersecting){ play(v); }
          else if(!v.paused){ v.pause(); }
        });
      }, {threshold:0.2});
      videos.forEach(function(v){ io.observe(v); });

      
      var kick = function(){ videos.forEach(function(v){ if(v._dlVisible) play(v); }); };
      document.addEventListener('touchstart', kick, {passive:true, once:true});
      document.addEventListener('click', kick, {once:true});
    }

    
    function step(){
      return slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : track.clientWidth;
    }

    function maxScroll(){
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function positions(){
      var s = step();
      return s > 0 ? Math.round(maxScroll() / s) + 1 : 1;
    }

    function buildDots(){
      var n = positions();
      if(dotsWrap.children.length !== n){
        dotsWrap.innerHTML = '';
        for(var i = 0; i < n; i++){
          (function(i){
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'cv-vs__dot';
            b.setAttribute('aria-label', CVT.gov + ' ' + (i + 1));
            b.addEventListener('click', function(){
              track.scrollTo({left:i * step(), behavior:behavior});
            });
            dotsWrap.appendChild(b);
          })(i);
        }
      }
      dotsWrap.hidden = n < 2;
    }

    function update(){
      var s = step();
      var idx = s > 0 ? Math.round(track.scrollLeft / s) : 0;
      [].forEach.call(dotsWrap.children, function(d, i){
        d.classList.toggle('is-active', i === idx);
        if(i === idx){ d.setAttribute('aria-current', 'true'); }
        else { d.removeAttribute('aria-current'); }
      });
      root.classList.toggle('is-static', maxScroll() < 4);
    }

    
    function go(dir){
      var m = maxScroll();
      var x = track.scrollLeft;
      if(dir > 0 && x >= m - 4){ track.scrollTo({left:0, behavior:behavior}); }
      else if(dir < 0 && x <= 4){ track.scrollTo({left:m, behavior:behavior}); }
      else { track.scrollBy({left:dir * step(), behavior:behavior}); }
    }

    if(prev) prev.addEventListener('click', function(){ go(-1); });
    if(next) next.addEventListener('click', function(){ go(1); });

    var ticking = false;
    track.addEventListener('scroll', function(){
      if(ticking) return;
      ticking = true;
      requestAnimationFrame(function(){ update(); ticking = false; });
    }, {passive:true});

    window.addEventListener('resize', function(){ buildDots(); update(); });

    buildDots();
    update();
  });
})();
